import { useUnifiedDetailsV2 } from './useUnifiedDetailsV2';
import { useUnifiedDetailsV3 } from './useUnifiedDetailsV3';
// We will continue to use this centralized useUnifiedDetails hook
// to alias the expected version bumps (V1, V2, V3, etc.)
// until things stabilize for release
export function useUnifiedDetails({
  appContext = 'app',
  slug,
  language,
  skip,
  version = 3
}) {
  const responseV3 = useUnifiedDetailsV3({
    appContext,
    slug,
    language,
    skip: skip || version !== 3
  });
  const responseV2 = useUnifiedDetailsV2({
    appContext,
    slug,
    language,
    skip: skip || version !== 2
  });
  if (version === 3) {
    return responseV3;
  }
  if (version === 2) {
    return responseV2;
  }
  return responseV3;
}